module.exports = __webpack_public_path__ + "img/technology.6458fb4d.png";